<template>
    <div class="table-container">
        <div class="left-table-box">
            <div class="master-head master-head-buttons">
                <ul class="button-ul">
                    <li class="master-head-list">
                        <div class="button-img">
                            <button class="vs-component vs-button button button-xl vs-button-primary vs-button-border"
                                    @click="updateView">
                                <span class="vs-button-text vs-button--text">Update</span>
                                <i class="reload"></i>
                            </button>
                        </div>
                    </li>
                    <!--                    <li class="master-head-list">-->
                    <!--                        <div class="button-img">-->
                    <!--                            <vs-button color="primary" type="border" class="button button-xl">Rememver View</vs-button>-->
                    <!--                            <i class="save"></i>-->
                    <!--                        </div>-->
                    <!--                    </li>-->
                </ul>
                <ul class="button-ul drop-options">
                    <li class="master-head-list" @click.stop="masterHeadListClick">
                        <p class="vs-con-dropdown b-dropdown-arrow" ref="masterHeadLink">
                            {{selectedCountry}} <i class="list-down-arrow arrow-down"></i>
                        </p>
                        <div class="report-header-options" ref="masterHeadListBtn">
                            <ul>
                                <li v-for="(country,index) in countryList" :key="index" @click="changeCountry(country)">
                                    <span>{{country.oeCountry}}</span>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="table-wrapper" ref="tableWrapperLap"> 
                <div class="master-table-head-box master-t-head-b">
                    <div class="master-table-head consulatant-cell left-pos-cell">
                        <div class="dropdown-setter" data-setter="consultant">
                            <div class="master-table-text left-table-header" @click="sortTable('consultant')">
                                Consultant
                            </div>
                            <div class="master-table-opt"></div>
                            <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="consultant">
                                <a href.prevent="" class="a-icon">
                                    <i :class="(consultantSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                </a>
                            </button>
                            <Dropdown>
                                <ul>
                                    <li>
                                        <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                        type="text" v-model="consultantSearch" class="dropdown-input"
                                               placeholder="Search">
                                    </li>
                                </ul>
                            </Dropdown>
                        </div>
                    </div>
                    <div class="master-table-head sap-cell">
                        <div class="dropdown-setter" data-setter="sapno">
                            <div class="master-table-text left-table-header" @click="sortTable('sap_no')">SAP no</div>
                            <div class="master-table-opt"></div>

                            <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="sapno">
                                <a href.prevent="" class="a-icon">
                                    <i :class="(sapNoSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                </a>
                            </button>
                            <Dropdown>
                                <ul>
                                    <li>
                                        <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                        type="text" v-model="sapNoSearch" class="dropdown-input"
                                               placeholder="Search">
                                    </li>
                                </ul>
                            </Dropdown>
                        </div>
                    </div>
                    <div class="master-table-head customer-cell">
                        <div class="dropdown-setter" data-setter="customer">
                            <div class="master-table-text left-table-header" @click="sortTable('customer')">Customer
                            </div>
                            <div class="master-table-opt"></div>
                            <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="customer">
                                <a href.prevent="" class="a-icon">
                                    <i :class="(customerSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                </a>
                            </button>
                            <Dropdown>
                                <ul>
                                    <li>
                                        <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                        type="text" v-model="customerSearch" class="dropdown-input"
                                               placeholder="Search">
                                    </li>
                                </ul>
                            </Dropdown>

                        </div>
                    </div>
                    <div class="master-table-head project-cell">
                        <div class="dropdown-setter" data-setter="project">
                            <div class="master-table-text left-table-header" @click="sortTable('project')">Project</div>
                            <div class="master-table-opt"></div>
                            <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="project">
                                <a href.prevent="" class="a-icon">
                                    <i :class="(projectSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                </a>
                            </button>
                            <Dropdown>
                                <ul>
                                    <li>
                                        <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                        type="text" v-model="projectSearch" class="dropdown-input"
                                               placeholder="Search">
                                    </li>
                                </ul>
                            </Dropdown>
                        </div>
                    </div>
                    <div class="master-table-head level-cell">
                        <div class="dropdown-setter" data-setter="level">
                            <div class="master-table-text left-table-header" @click="sortTable('level')">Level</div>
                            <div class="master-table-opt"></div>
                            <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="level">
                                <a href.prevent="" class="a-icon">
                                    <i :class="(levelSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                </a>
                            </button>
                            <Dropdown>
                                <ul>
                                    <li>
                                        <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                        type="text" v-model="levelSearch" class="dropdown-input"
                                               placeholder="Search">
                                    </li>
                                </ul>
                            </Dropdown>
                        </div>
                    </div>
                    <div class="master-table-head start-cell">
                        <div class="dropdown-setter" data-setter="start">
                            <div class="master-table-text left-table-header" @click="sortTable('start')">Start</div>
                            <div class="master-table-opt"></div>
                            <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="start">
                                <a href.prevent="" class="a-icon">
                                    <i :class="(startSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                </a>
                            </button>
                            <Dropdown class="date-dropdown-box view-header-table-view">
                                <div class="date-close-pos">
                                    <input type="text" class="dropdown-input dropdown-input-date"
                                           disabled placeholder="Search" v-model="startSearch">
                                    <a class="close-button"
                                       @click.prevent="startSearch = null; datePickerOnChange()"></a>
                                </div>
                                <vue-date-picker v-model="start" @onChange="datePickerOnChange()" visible no-header
                                                 inline
                                                 validate></vue-date-picker>


                            </Dropdown>
                        </div>
                    </div>
                    <div class="master-table-head end-cell">
                        <div class="dropdown-setter" data-setter="end">
                            <div class="master-table-text left-table-header" @click="sortTable('end')">End</div>
                            <div class="master-table-opt"></div>
                            <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="end">
                                <a href.prevent="" class="a-icon">
                                    <i :class="(endSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                </a>
                            </button>
                            <Dropdown class="date-dropdown-box view-header-table-view">
                                <div class="date-close-pos">
                                    <input type="text" disabled class="dropdown-input dropdown-input-date"
                                           placeholder="Search" v-model="endSearch">
                                    <a class="close-button" @click.prevent="endSearch=null; datePickerOnChange()"></a>
                                </div>
                                <vue-date-picker v-model="end" @onChange="datePickerOnChange()" visible no-header inline
                                                 validate></vue-date-picker>

                            </Dropdown>
                        </div>
                    </div>
                    <div class="master-table-head engag-cell">
                        <div class="dropdown-setter" data-setter="enga">
                            <div class="master-table-text left-table-header" @click="sortTable('engagement')">Enga.%
                            </div>
                            <div class="master-table-opt"></div>
                            <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="enga">
                                <a href.prevent="" class="a-icon">
                                    <i :class="(engagementSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                </a>
                            </button>
                            <Dropdown>
                                <ul>
                                    <li><input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" v-model="engagementSearch" class="dropdown-input"
                                               :class="{'error-border':searchError.engagement}"
                                               placeholder="Filter"></li>
                                </ul>
                            </Dropdown>
                        </div>
                    </div>
                    <div class="master-table-head rate-cell">
                        <div class="dropdown-setter" data-setter="rate">
                            <div class="master-table-text left-table-header" @click="sortTable('rate')">Rate</div>
                            <div class="master-table-opt"></div>
                            <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="rate">
                                <a href.prevent="" class="a-icon">
                                    <i :class="(rateSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                </a>
                            </button>
                            <Dropdown>
                                <ul>
                                    <li><input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" v-model="rateSearch" class="dropdown-input"
                                               :class="{'error-border':searchError.rate}"
                                               placeholder="Filter"></li>
                                </ul>
                            </Dropdown>
                        </div>
                    </div>
                    <div class="master-table-head left-days-cell right-pos-cell">
                        <div class="dropdown-setter" data-setter="dl">
                            <div class="master-table-text left-table-header" @click="sortTable('days_left')">Days Left
                            </div>
                            <div class="master-table-opt"></div>
                            <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="dl">
                                <a href.prevent="" class="a-icon">
                                    <i :class="(daysLeftSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                </a>
                            </button>
                            <Dropdown>
                                <ul>
                                    <li>
                                        <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                        type="text" v-model="daysLeftSearch" class="dropdown-input"
                                               :class="{'error-border':searchError.days_left}"
                                               placeholder="Filter"></li>
                                </ul>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <relation/>
            </div>
        </div>
        <results/>
    </div>
</template>

<script>
    import settings from "../../../config/settings";
    import searchKeys from "../../../config/searchKeys";
    import {VueDatePicker} from "@mathieustan/vue-datepicker";

    const Results = () => import("./relations/Results");
    const Relation = () => import("./relations/Relation");
    const Dropdown = () => import('../../common/Dropdown');
    import _ from "lodash";

    export default {
        name: "Relations",
        components: {Results, Relation, Dropdown, VueDatePicker},
        data: () => {
            return {
                timeout: 0,
                currentCountry: "",
                searchError: {
                    engagement: false,
                    rate: false,
                    days_left: false,
                },
                start: null,
                end: null
            }
        },
        computed: {
            /**
             * Get the current date
             */
            today: function () {
                let today = new Date();
                let dd = String(today.getDate()).padStart(2, '0');
                let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                let yyyy = today.getFullYear();
                today = mm + '/' + dd + '/' + yyyy;
                return today;
            },
            /**
             * Search inside consultant value
             */
            consultantSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.forecast.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.consultant);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.consultant.trim(),
                        value: value
                    };
                    this.$store.commit("setSearchData", data);
                }
            },
            sapNoSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.forecast.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.sap_no);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    // commit the updated value into the store
                    let data = {
                        key: searchKeys.sap_no.trim(),
                        value: value
                    };
                    this.$store.commit("setSearchData", data);
                }
            },
            customerSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.forecast.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.customer);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    // commit the updated value into the store
                    let data = {
                        key: searchKeys.customer.trim(),
                        value: value
                    };
                    this.$store.commit("setSearchData", data);
                }
            },
            projectSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.forecast.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.project);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    // commit the updated value into the store
                    let data = {
                        key: searchKeys.project.trim(),
                        value: value
                    };
                    this.$store.commit("setSearchData", data);
                }
            },
            levelSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.forecast.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.level);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    // commit the updated value into the store
                    let data = {
                        key: searchKeys.level.trim(),
                        value: value
                    };
                    this.$store.commit("setSearchData", data);
                }
            },
            startSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.forecast.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.start);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    // commit the updated value into the store
                    let data = {
                        key: searchKeys.start.trim(),
                        value: value
                    };
                    this.$store.commit("setSearchData", data);
                }
            },
            endSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.forecast.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.end);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    // commit the updated value into the store
                    let data = {
                        key: searchKeys.end.trim(),
                        value: value
                    };
                    this.$store.commit("setSearchData", data);
                }
            },
            engagementSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.forecast.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.engagement);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    // commit the updated value into the store
                    let data = {
                        key: searchKeys.engagement.trim(),
                        value: value
                    };
                    this.$store.commit("setSearchData", data);
                }
            },
            rateSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.forecast.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.rate);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    // commit the updated value into the store
                    let data = {
                        key: searchKeys.rate.trim(),
                        value: value
                    };
                    this.$store.commit("setSearchData", data);
                }
            },
            daysLeftSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.forecast.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.days_left);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    // commit the updated value into the store
                    let data = {
                        key: searchKeys.days_left.trim(),
                        value: value
                    };
                    this.$store.commit("setSearchData", data);
                }
            },
            filter: function () {
                return this.$store.state.forecast.filter;
            },
            relations: function () {
                return this.$store.state.forecast.users;
            },
            countryList: function () {
                let countryList = this.$store.state.forecast.oe_countries;
                countryList.push({oeCountry: "All", itemId: 'null'});
                return countryList;
            },
            user: function () {
                return this.$store.state.auth.podio_user;
            },
            selectedCountry: function () {
                // get current country filter from store
                let country = this.filter.filterParams.find(p => p.fieldName === searchKeys.oe);
                // if exists
                if (country) {
                    // get the name from country list
                    return this.countryList.find(c => c.itemId === country.value).oeCountry;
                }
                return this.currentCountry;
            }
        },
        methods: {
            /**
             * Submit the search result
             * Wait for the user to finish the typing
             */
            submitSearchResult: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = settings.initial_forecast_row_count;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    // fetch the forecast with the search data
                    this.$store.dispatch("fetchForecast", filter).then(
                        // fetch results on response
                        () => this.$store.dispatch("fetchForecastResult", filter)
                    );
                }, 700);
            },
            /**
             * Update data by refetching the current data only
             */
            updateView: function () {
                // set the default value for the rows fetch
                let rowCount = settings.initial_forecast_row_count;
                // clone the current filter data
                let filter = _.cloneDeep(this.filter);
                // set the number of rows to be fetched to the current data length
                if (this.relations && this.relations.length && this.relations.length > settings.initial_forecast_row_count) {
                    rowCount = this.relations.length;
                }
                // set row count
                filter.pageSize = rowCount;
                // set the page number to 1
                filter.pageNumber = 1;
                // send request
                this.$store.dispatch("fetchForecast", filter).then(
                    // fetch result on response
                    () => this.$store.dispatch("fetchForecastResult", filter)
                );

            },
            /**
             * Sort table by column
             * @param column
             */
            sortTable: function (column) {
                let rowCount = settings.initial_forecast_row_count;
                //clone the filter
                let filter = this.filter;
                let filterData = _.cloneDeep(filter);
                // if no sort set or sort set for another column
                if (!filter.sortColumn || filter.sortColumn !== searchKeys[column]) {
                    this.$store.commit("setSort", {column: searchKeys[column], order: 'ASC'});
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                } else if (filter.sortColumn === searchKeys[column] && filter.sortOrder === 'ASC') {
                    this.$store.commit("setSort", {column: searchKeys[column], order: 'DESC'});
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'DESC';
                } else if (filter.sortColumn === searchKeys[column] && filter.sortOrder === 'DESC') {
                    this.$store.commit("setSort", {column: searchKeys[column], order: 'ASC'});
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                }
                if (this.relations && this.relations.length && this.relations.length > settings.initial_forecast_row_count) {
                    rowCount = this.relations.length;
                }
                // set row count
                filterData.pageSize = rowCount;
                // set the page number to 1
                filterData.pageNumber = 1;
                // request data with filter
                this.$store.dispatch("fetchForecast", filterData).then(
                    // fetch result on response
                    () => this.$store.dispatch("fetchForecastResult", filterData)
                );

                //Close picker once the action is completed.
                this.datePickerOnChange();
            },
            /**
             * Click event handle for the dropdown
             * @param event
             */
            masterHeadListClick: function (event) {
                //Close main header style.
                setTimeout(function(){
                if(document.querySelector('.report-subheader-nav') != undefined && document.querySelector('.report-subheader-nav') != null){
                    document.querySelector('.report-subheader-nav').classList.remove('open-report-nav');
                }
                }, 100)
                
                if (document.querySelector('.menu-dropdown.open-d') != null & document.querySelector('.menu-dropdown.open-d') != undefined) {
                    document.querySelector('.menu-dropdown.open-d').classList.remove('open-d');
                }

                if (event.srcElement.nextElementSibling && event.srcElement.nextElementSibling.classList && event.srcElement.nextElementSibling.classList.contains('r-open')) {
                    this.$refs.masterHeadListBtn.classList.remove('r-open');
                } else {
                    if (this.$refs.masterHeadListBtn && this.$refs.masterHeadListBtn.classList) {
                        this.$refs.masterHeadListBtn.classList.add('r-open');

                    }

                }
            },
            /**
             * Change the current oe country
             * Send request with the selected OE country
             * @param country
             */
            changeCountry: function (country) {
                // if not already selected
                if (this.currentCountry !== country.oeCountry) {
                    // set the selected country
                    this.currentCountry = country.oeCountry;
                    // update the country data into store filter
                    let data = {
                        key: searchKeys.oe,
                        value: country.itemId
                    };
                    this.$store.commit("setSearchData", data);
                    // submit the filter
                    this.submitSearchResult();
                }
            },

            datePickerOnChange: function () {
                //Closing the popup when a value is selected
                if (document.querySelectorAll('.view-header-table-view') != undefined || document.querySelectorAll('.view-header-table-view') != null) {
                    document.querySelectorAll('.view-header-table-view').forEach((elem) => {
                        elem.classList.remove('open-d');
                    });
                }
            },
            
            wrappingLap: function(){
                // this.$refs.table-wrapper-lap
                var el = this.$refs.tableWrapperLap;
                if(!el.closest('.table-wrapper-outer')){
                    
                    var wrapper = document.createElement('div');
                    wrapper.classList.add('table-wrapper-outer');
                    el.parentNode.insertBefore(wrapper, el);
                    wrapper.appendChild(el);
                }
            }
            
        },
        mounted() {
            document.body.addEventListener('click', (e) => {
                if (e.srcElement !== this.$refs.masterHeadListBtn && this.$refs.masterHeadListBtn && this.$refs.masterHeadListBtn.classList) {
                    this.$refs.masterHeadListBtn.classList.remove('r-open');
                }
                
            });
            this.wrappingLap();    
            
            window.addEventListener('resize', () =>{
                var fl = false;
                if(screen.width <= 1440){
                    if(!fl){
                        this.wrappingLap();
                    }
                }
                else{
                    
                    fl = true;
                } 
            });
            
        },
        created() {
            // if the user has oe country, then set as current
            if (this.user) {
                this.currentCountry = this.user.oeCountry;
            }

            this.start = this.today;
            this.end = this.today;
        },
        watch: {
            consultantSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            sapNoSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            customerSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            projectSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            levelSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            startSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            endSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            },
            engagementSearch: function (value) {
                if (!value || /^(\d)+(.\d+)?$/.test(value)) {
                    this.searchError.engagement = false;
                    this.submitSearchResult();
                } else this.searchError.engagement = !!value;
            },
            rateSearch: function (value) {
                if (!value || /^(\d)+(.\d+)?$/.test(value)) {
                    this.searchError.rate = false;
                    this.submitSearchResult();
                } else this.searchError.rate = !!value;
            },
            daysLeftSearch: function (value) {
                if (!value || /^(\d)+(.\d+)?$/.test(value)) {
                    this.searchError.days_left = false;
                    this.submitSearchResult();
                } else this.searchError.days_left = !!value;
            },
            user: function (value) {
                // set the current oe country
                if (value) {
                    this.currentCountry = value.oeCountry;
                }
            },
            start: function (value, prevValue) {
                if (prevValue) {
                    this.startSearch = value;
                }
            },
            end: function (value, prevValue) {
                if (prevValue) {
                    this.endSearch = value;
                }
            }
        }

    }
</script>

<style>
    .bo {
        border: 1px solid #ff0000;
    }

    .master-head-list {
        position: relative;
    }

    .report-header-options {
        position: absolute;
        top: 30px;
        left: 0;
        height: auto;
        max-height: 0;
        width: 220px;
        background: #ffffff;
        z-index: 997;
        box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
        -moz-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
        -webkit-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
        overflow: hidden;
    }

    .report-header-options.r-open {
        max-height: 400px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .report-header-options li {
        padding: 14px 20px;
        cursor: pointer;
    }

    .report-header-options li.active {

    }

    /* new style for consultant space */
    .master-table-head-box .rate-cell {
        min-width: 82px;
        width: 82px;
        max-width: 82px;
    }

    .master-table-head-box .consulatant-cell {
        min-width: 197px;
        width: 197px;
        max-width: 197px;
    }


    .master-table .rate-cell {
        min-width: 82px;
        width: 82px;
        max-width: 82px;
    }


    .report-header-options .li-header-active span {
        position: relative;
    }

    .report-header-options .li-header-active span:after {
        content: "";
        width: 100%;
        height: 1px;
        background: #a0a0a0;
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .error-border {
        border: 1px solid red;
    }


</style>
